var map = {
	"./AlmenWong.jpg": 1518,
	"./BerniceAntoine.jpg": 1734,
	"./ChristianSuen.jpeg": 9117,
	"./MeganJaques.png": 1733,
	"./StephanieLowe.jpg": 3394,
	"./VincentLee.jpg": 5107
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6384;